export const EmptyState = ({ icon: Icon, title, sub, action, testId }) => (
  <div data-testid={testId} className="flex flex-col items-center rounded-2xl bg-white px-6 py-12 text-center shadow-[0_1px_3px_rgba(11,37,69,0.06)] animate-in fade-in duration-500">
    {Icon && <span className="grid h-14 w-14 place-items-center rounded-2xl bg-brand/10 text-brand"><Icon className="h-6 w-6" /></span>}
    <h3 className="mt-4 text-base font-semibold text-navy">{title}</h3>
    {sub && <p className="mt-1 max-w-xs text-sm text-slate-500">{sub}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const SkeletonBlock = ({ className = "" }) => <div className={`animate-pulse rounded-2xl bg-slate-200/70 ${className}`} />;

export const ErrorNote = ({ text, testId = "load-error" }) => (
  <p data-testid={testId} className="rounded-2xl bg-rose-50 px-4 py-3 text-sm text-rose-700">{text}</p>
);
